import { useMutation } from "@apollo/client";

import { ActionShareGoalInviteMutation, ActionShareGoalInviteMutationVariables } from "@ctypes";
import { ACTION_SHARE_GOAL_INVITE, RECEIVED_SHARE_GOAL_INVITES, USER } from "@graphql";

export const useActionShareGoalInvite = () => {
  return useMutation<ActionShareGoalInviteMutation, ActionShareGoalInviteMutationVariables>(
    ACTION_SHARE_GOAL_INVITE,
    {
      awaitRefetchQueries: true,
      refetchQueries: [{ query: RECEIVED_SHARE_GOAL_INVITES }, { query: USER }],
    },
  );
};
